/** @file The Curves tab as the Timeline panel mounts it: CurvesView on the live editor ports. */
import { curvePortsLive } from './curvePortsLive';
import { CurvesView } from './CurvesView';

/** No props: the Timeline panel renders it as the body of its `curves` tab (label `t('curves.tab')`). */
export function CurvesTab() {
  return <CurvesView ports={curvePortsLive} />;
}
